export const getRawTickerFromCatalogValue = (symbol) => {
  const normalizedSymbol = String(symbol || "").trim();

  if (/^EQ-/i.test(normalizedSymbol)) {
    return normalizedSymbol.slice(normalizedSymbol.indexOf("-") + 1);
  }

  return normalizedSymbol;
};
